import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import { DashboardKpisResponse } from './types';

export interface DashboardKpisParams {
  period?: 'mtd' | 'ytd' | '30d' | '90d' | 'custom';
  start_date?: string;
  end_date?: string;
  organization_id?: string;
}

/**
 * Hook to fetch aggregated financial KPIs from GET /api/v2/dashboard/kpis/
 */
export function useDashboardKpis(params: DashboardKpisParams = { period: 'mtd' }) {
  return useQuery<DashboardKpisResponse>({
    queryKey: ['dashboard-kpis', params],
    queryFn: async () => {
      const response = await api.get<DashboardKpisResponse>('/v2/dashboard/kpis/', {
        params,
      });
      return response.data;
    },
    staleTime: 60 * 1000, // 1 minute
  });
}
